import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';
import NetworkVisual from '../visuals/NetworkVisual';

const Cta = () => {
  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: 'https://calendly.com/prboost7/30-minutes-meeting' });
    }
  };

  return (
    <section className="pt-32 pb-12 relative overflow-hidden bg-[#070b14]">
      <NetworkVisual />
      
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-blue-600/20 blur-[120px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl md:text-7xl font-extrabold text-white mb-8 tracking-tighter"
        >
          Start Building <span className="text-gradient">Authority That Ranks</span>
        </motion.h2>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-xl md:text-2xl text-slate-400 mb-12 max-w-2xl mx-auto leading-relaxed"
        >
          Launch campaigns, secure real placements, and scale your link building with a platform built for results
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
        >
          <Button href="https://app.prboost.io/" variant="primary" className="!px-10 !py-5 text-xl shadow-[0_0_50px_rgba(59,130,246,0.4)] hover:shadow-[0_0_70px_rgba(59,130,246,0.6)]">
            Create an Account
          </Button>
          <Button 
            variant="secondary" 
            className="!px-10 !py-5 text-xl"
            onClick={openCalendly}
          >
            Book a Call
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default Cta;
